/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_R_FormsInputs */

const en_pc_cmp_r_forms = /** @type {(inputs: Pc_Cmp_R_FormsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forms`)
};

const zh_pc_cmp_r_forms = /** @type {(inputs: Pc_Cmp_R_FormsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`表单`)
};

/**
* | output |
* | --- |
* | "Forms" |
*
* @param {Pc_Cmp_R_FormsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_r_forms = /** @type {((inputs?: Pc_Cmp_R_FormsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_R_FormsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_r_forms(inputs)
	return zh_pc_cmp_r_forms(inputs)
});
export { pc_cmp_r_forms as "pc.cmp.r.forms" }